import Components from './components/index';
import Hooks from './hooks/index';
import Modals from './modals/index';
import Pages from './pages/index';
import Providers from './providers';
import PusherChannels from './pusher-channels';
import Services from './services/index';
import Shared from './shared';
import Modules from './modules';
import Features from './features';

export default {
  Pages,
  Modals,
  Hooks,
  Components,
  Providers,
  PusherChannels,
  Services,
  Shared,
  Modules,
  Features,
};
